import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ZkICheckoutSummaryItem } from '@zenklub/ng-ui';
import { ZkNotificationService } from '@zenklub/ng-ui';
import { IProfessionalCart } from 'app/interfaces/checkout.interface';
import { GlobalService } from 'app/services/global.service';
import { UserService } from 'app/services/user.service';

@Component({
	selector: 'app-checkout-success',
	templateUrl: './checkout-success.component.html',
	styleUrls: ['./checkout-success.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CheckoutSuccessComponent implements OnInit {
	isMobile = false;
	userImage = '';

	cart: IProfessionalCart;
	isLoading = true;

	constructor(
		private globalService: GlobalService,
		private notificationService: ZkNotificationService,
		private router: Router,
		private translateService: TranslateService,
		private userService: UserService
	) {
		const { cart } = history.state;
		this.cart = cart;
	}

	ngOnInit() {
		this.onResize();
		this.getUserImage();

		if (this.cart) {
			const selectedMethod = this.cart.paymentMethods.find((m) => m.selected);

			switch (selectedMethod.type) {
				case 'card':
					if (this.cart.items.plan) {
						this.notificationService.showSuccess(
							this.translateService.instant('PAYMENT_SUCCESS.PLAN_SUCCESS')
						);
					}
			}

			this.isLoading = false;
		} else {
			this.router.navigateByUrl('/account/premium');

			this.notificationService.showError(
				this.translateService.instant('CHECKOUT.RESULT_ERROR')
			);
		}
	}

	handleCartItems() {
		const items: ZkICheckoutSummaryItem[] = [];

		const { plan } = this.cart.items;

		if (
			plan ||
			(this.cart.suggestedContent &&
				this.cart.suggestedContent.suggestion.isSelected)
		) {
			const summaryPlan = plan || this.cart.suggestedContent.plan;
			items.push({
				type: 'plan',
				label: `${summaryPlan.name}`,
				value: summaryPlan.price,
			});
		}

		if (this.cart.summary.discounts.length) {
			this.cart.summary.discounts.forEach(({ label, value }) =>
				items.push({
					type: 'discount',
					label,
					value,
				})
			);
		}

		return items;
	}

	handleCart() {
		return {
			...this.cart,
			items: this.handleCartItems(),
		};
	}

	onResize() {
		this.isMobile = this.globalService.isMobileDevice();
	}

	getUserImage() {
		if (this.isMobile) {
			// Get user's picture.
			const userLocal = this.userService.getUserLocal();
			this.userImage =
				(userLocal && userLocal.image) ||
				this.globalService.getDefaultUserPicture();
		}
	}
}
